<template>
  <app-collapse type="margin">
    <app-collapse-item
      :title="$t('service-subscription.subscription')"
      :is-visible="true"
    >
      <subscription-settings />
    </app-collapse-item>
  </app-collapse>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

import SubscriptionSettings from './SubscriptionSettings/SubscriptionSettings.vue'

export default {
  components: {
    AppCollapse,
    AppCollapseItem,

    SubscriptionSettings,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
}
</script>
